import { IBreakpoints } from '../interfaces'
import { IAnimationConfig, animation } from './animation.config'
import { breakpoints } from './breakpoint.config'
import { ICartConfig, cart } from './cart.config'
import { IDeliveryZonesConfig, deliveryZones } from './delivery-zones.config'
import { IEnvironmentConfig, environment } from './environment.config'
import { IPersistConfig, persist } from './persist.config'
import { IShopifyConfig, shopify } from './shopify.config'

export interface IConfig {
  animation: IAnimationConfig
  breakpoints: IBreakpoints<number>
  cart: ICartConfig
  deliveryZones: IDeliveryZonesConfig
  environment: IEnvironmentConfig
  persist: IPersistConfig
  shopify: IShopifyConfig
}

export const CONFIG: IConfig = {
  animation,
  breakpoints,
  cart,
  deliveryZones,
  environment,
  persist,
  shopify,
}
